import React, { useEffect } from "react";
import centerLogo from "../assets/TIGlogo.jpeg";
import logo1 from '../assets/vodafone.png';
import logo2 from '../assets/elevate.png';
import logo3 from '../assets/reen.png';
import logo4 from '../assets/contracting.png';
import logo5 from '../assets/outsourcing.png';
import logo6 from '../assets/MBC.png';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaCheckCircle } from "react-icons/fa";
import aboutwhy from '../assets/TIG Website Images/About Us/dfdsfdf.png'

const WhyPartner = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="why-partner container-fluid py-5 px-3 px-md-3" data-aos="fade-up">
      <div className="row align-items-center">
        {/* Left: Circular Logos */}
        <div className="col-md-6 mt-0 mt-md-3 mb-4 mb-md-0 d-flex justify-content-center justify-content-md-start">
          {/* <div className="circle-container">
            <img src={centerLogo} alt="Towers" className="center-logo" />
 <div className="inner-circle">
              <img src={logo1} className="orbit-logo orbit1" alt="Vodafone" />
              <img src={logo2} className="orbit-logo orbit2" alt="Elevate" />
            </div>
  <div className="outer-circle">
              <img src={logo3} className="orbit-logo orbit3" alt="Reen" />
              <img src={logo4} className="orbit-logo orbit4" alt="Contracting" />
              <img src={logo5} className="orbit-logo orbit5" alt="Outsourcing" />
              <img src={logo6} className="orbit-logo orbit6" alt="MBC" />
            </div>
          </div> */}
          <img
              src={aboutwhy}
              alt="about-1"
              className="img-fluid rounded shadow mb-4"
              style={{height:"459PX",}}
            /> 
        </div>

        {/* Right: Text Content */}
        <div className="col-md-6 px-4 px-md-2">
          <h2 className="fw-bold mb-3">
            Why Partner <span className="highlight" > with TIG?</span>
          </h2>
          <p className="Tig-para-benifts text-muted">
            TIG’s outsourcing model helps clients reduce operational costs, access trained professionals,
            and focus on core growth. Our trusted divisions deliver excellence in finance, IT, advertising,
            and manpower—backed by strong relationships and a large expert database.
          </p>

          <h5 className="fw-bold mt-4">Benefits of Outsourcing</h5>
          <ul className="list-unstyled benefits-list text-muted">
            <li><FaCheckCircle className="text-success me-2" /> <strong className="text-dark">Cost Saving –</strong> Reduce management load and overheads.</li>
            <li><FaCheckCircle className="text-success me-2" /> <strong className="text-dark">Core Focus –</strong> Let clients concentrate on key operations.</li>
            <li><FaCheckCircle className="text-success me-2" /> <strong className="text-dark">Training Advantage –</strong> Lower manpower training costs.</li>
            <li><FaCheckCircle className="text-success me-2" /> <strong className="text-dark">Quality Delivery –</strong> Skilled professionals with expertise.</li>
            <li><FaCheckCircle className="text-success me-2" /> <strong className="text-dark">Strategic Partnerships –</strong> Long-term value-driven relations.</li>
            <li><FaCheckCircle className="text-success me-2" /> <strong className="text-dark">Talent Pool Access –</strong> Ready database of expert CVs.</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WhyPartner;
